import { secureApi } from './secureApi';

// The cleaning window on either side of a booking's operational times
// (tasks/arrival-readiness-action-side.md Phase 2). The server computes it — the card never
// re-implements the rule, so what the live line says and what the save enforces cannot differ.
//
// Field semantics for both calls: omitted/undefined = unchanged, null = cleared (the unit's
// normal time), otherwise an ISO instant.
const turnoverApi = {
  // GET /api/v1/bookings/:id/operational-times/turnover — read-only preview (L5)
  preview: async (bookingId, { expectedArrivalAt, expectedDepartureAt } = {}) => {
    const params = {};
    if (expectedArrivalAt !== undefined) params.expectedArrivalAt = expectedArrivalAt || '';
    if (expectedDepartureAt !== undefined) params.expectedDepartureAt = expectedDepartureAt || '';
    const response = await secureApi.get(
      `/api/v1/bookings/${bookingId}/operational-times/turnover`,
      { params }
    );
    return response.data;
  },

  // PATCH /api/v1/bookings/:id/operational-times — 409 TURNOVER_001 when it would put the next
  // guest in the unit before the last one leaves; `preserveBackendError` so `code` survives.
  saveOperationalTimes: async (bookingId, payload) => {
    const response = await secureApi.patch(
      `/api/v1/bookings/${bookingId}/operational-times`,
      payload,
      { preserveBackendError: true }
    );
    return response.data;
  }
};

export default turnoverApi;
